<div [ngClass]="isModal?'px-2':''">
    @if (isModal) {
    <app-page-breadcrumb [pageInfo]="pageInfo" [isModal]="isModal"></app-page-breadcrumb>}
    <div class=" info_view">
        <div class="img_view">
            <table class="table">

                <th><b> Basic Profile</b></th>
            </table>
        </div>
        <div style="color:black">
            <div class="col-lg-12">
                <div class="card mb-12">
                    <div class="row g-0">
                        <div class="col-md-2 p-1">
                            <img imageLoad [src]="StudentSourceData?.profile_image_path" class="mb-3 img-thumbnail"
                                [style.height.px]="150">
                        </div>
                        <div class="col-md-10">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <table>
                                            <tr>
                                                <td><b>Name</b> </td>
                                                <td> : {{StudentSourceData?.studentName}}</td>
                                            </tr>

                                            <tr>
                                                <td><b>Gender</b> </td>
                                                <td> : {{StudentSourceData?.genderName}}</td>
                                            </tr>
                                            <tr>
                                                <td class="col-6"><b>Aadhaar No</b> </td>
                                                <td class="col-6">: {{StudentSourceData?.aadhaar_no}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Blood Group</b> </td>
                                                <td> : {{StudentSourceData?.blood_groupName}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Institution generated Student Id</b> </td>
                                                <td> : {{StudentSourceData?.student_code}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="col-md-6">
                                        <table>
                                            <tr>
                                                <td><b>Date of Birth</b> </td>
                                                <td> : {{StudentSourceData?.dob |
                                                    date:'dd-MMM-yyyy'}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Age</b> </td>
                                                <td> : {{StudentSourceData?.age}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Father/Guardian Name</b> </td>
                                                <td> : {{StudentSourceData?.father_name}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Father Mobile Number</b> </td>
                                                <td> : {{StudentSourceData?.father_mobile_no}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Mother Name</b> </td>
                                                <td> : {{StudentSourceData?.mother_name}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Mother Mobile Number</b> </td>
                                                <td> : {{StudentSourceData?.mother_mobile_no}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <table class="table">

            <th><b> Student Institution Data</b></th>
        </table>
        <div class="row">

            <div class="col-md-6" style="color:black">
                <div class="mb-6">
                    <table>
                        <tr>
                            <td><b>Institution</b> </td>
                            <td> : {{StudentSourceData?.schoolName}}</td>
                        </tr>
                        <tr>
                            <td><b>Academic Year</b> </td>
                            <td> : {{StudentSourceData?.academic_year|
                                date:'dd-MMM-yyyy' }}</td>
                        </tr>
                        <tr>
                            <td><b>Admission Date</b> </td>
                            <td> : {{StudentSourceData?.admission_date |
                                date:'dd-MMM-yyyy'}}</td>
                        </tr>
                        <tr>
                            <td><b>Fees Discount Group</b> </td>
                            <td> : {{StudentSourceData?.fees_discount_groupName}}</td>
                        </tr>
                        <tr>
                            <td><b>Created by</b> </td>
                            <td> : {{StudentSourceData?.created_byName }}</td>
                        </tr>
                        <tr>
                            <td><b>Updated by</b> </td>
                            <td> : {{StudentSourceData?.last_modify_byName}}</td>
                        </tr>
                        @if (StudentSourceData?.status==1?StudentSourceData?.remarks:StudentSourceData?.reason_relive) {
                        <tr>
                            <td><b>{{StudentSourceData?.status==1?"Remarks":"Reason"}}</b> </td>
                            <td> :
                                {{StudentSourceData?.status==1?StudentSourceData?.remarks:StudentSourceData?.reason_relive}}
                            </td>
                        </tr>}
                    </table>
                </div>
            </div>

            <div class="col-md-6" style="color:black">
                <div class="mb-6">
                    <table>
                        <tr>
                            <td><b>Class of Study </b></td>
                            <td> : {{StudentSourceData?.courseName}}</td>
                        </tr>
                        <tr>
                            <td><b>Admission Number</b> </td>
                            <td> : {{StudentSourceData?.admission_no}}</td>
                        </tr>
                        <tr>
                            <td><b>Admission Class</b> </td>
                            <td> : {{StudentSourceData?.admission_className}}</td>
                        </tr>
                        @if (StudentSourceData?.optional_fees_typeName) {
                        <tr>
                            <td><b>Optional Fee</b> </td>
                            <td> : {{StudentSourceData?.optional_fees_typeName}}</td>
                        </tr>}
                        <tr>
                            <td><b>Pending Fees</b> </td>
                            <td> : {{StudentSourceData?.total_non_paid}}</td>
                        </tr>
                        @if (StudentSourceData?.updated_at) {
                        <tr>
                            <td><b>last Modified on</b> </td>
                            <td> : {{StudentSourceData?.updated_at |
                                date:'dd-MMM-yyyy'}}</td>
                        </tr>
                        }

                    </table>

                </div>
            </div>
        </div>
    </div>
</div>